(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("prop-types"), require("@material/ripple/dist/mdc.ripple"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "prop-types", "@material/ripple/dist/mdc.ripple"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("prop-types"), require("@material/ripple/dist/mdc.ripple")) : factory(root["react"], root["classnames"], root["prop-types"], root["@material/ripple/dist/mdc.ripple"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_5__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 3);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
      /***/
    },
    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.RippleMaterialIcon = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(0);

      var _react2 = _interopRequireDefault(_react);

      var _classnames = __webpack_require__(1);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _propTypes = __webpack_require__(2);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _reactRipple = __webpack_require__(4);

      var _reactRipple2 = _interopRequireDefault(_reactRipple);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.


      var MaterialIcon = function (_React$Component) {
        _inherits(MaterialIcon, _React$Component);

        function MaterialIcon() {
          _classCallCheck(this, MaterialIcon);

          return _possibleConstructorReturn(this, (MaterialIcon.__proto__ || Object.getPrototypeOf(MaterialIcon)).apply(this, arguments));
        }

        _createClass(MaterialIcon, [{
          key: 'render',
          value: function render() {
            var _props = this.props,
                icon = _props.icon,
                hasRipple = _props.hasRipple,
                otherProps = _objectWithoutProperties(_props, ['icon', 'hasRipple']);

            if (hasRipple) {
              return _react2.default.createElement(RippleMaterialIcon, _extends({
                unbounded: true,
                hasRipple: true,
                icon: icon
              }, otherProps));
            }

            return _react2.default.createElement(MaterialIconDefault, _extends({
              icon: icon
            }, otherProps));
          }
        }]);

        return MaterialIcon;
      }(_react2.default.Component);

      exports.default = MaterialIcon;

      var MaterialIconDefault = function MaterialIconDefault(props) {
        var className = props.className,
            icon = props.icon,
            initRipple = props.initRipple,
            hasRipple = props.hasRipple,
            otherProps = _objectWithoutProperties(props, ['className', 'icon', 'initRipple', 'hasRipple']);

        var classes = (0, _classnames2.default)('material-icons', className, {
          'material-icons--ripple-surface': hasRipple
        });
        return _react2.default.createElement('i', _extends({
          className: classes,
          ref: initRipple
        }, otherProps), icon);
      };

      var RippleMaterialIcon = exports.RippleMaterialIcon = (0, _reactRipple2.default)(MaterialIconDefault);
      MaterialIcon.propTypes = {
        icon: _propTypes2.default.string,
        hasRipple: _propTypes2.default.bool
      };
      MaterialIcon.defaultProps = {
        icon: '',
        hasRipple: false
      };
      MaterialIconDefault.propTypes = {
        icon: _propTypes2.default.string,
        className: _propTypes2.default.string,
        initRipple: _propTypes2.default.func,
        hasRipple: _propTypes2.default.bool
      };
      MaterialIconDefault.defaultProps = {
        icon: '',
        className: '',
        initRipple: function initRipple() {},
        hasRipple: false
      };
      /***/
    },
    /* 4 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(0);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(2);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(1);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _mdc = __webpack_require__(5);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.


      var withRipple = function withRipple(WrappedComponent) {
        var RippledComponent = function (_Component) {
          _inherits(RippledComponent, _Component);

          function RippledComponent() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, RippledComponent);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RippledComponent.__proto__ || Object.getPrototypeOf(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.foundation_ = null, _this.isMounted_ = true, _this.state = {
              classList: new Set(),
              style: {}
            }, _this.initializeFoundation_ = function (surface, activator) {
              var adapter = _this.createAdapter_(surface, activator);

              _this.foundation_ = new _mdc.MDCRippleFoundation(adapter);

              _this.foundation_.init();
            }, _this.createAdapter_ = function (surface, activator) {
              var MATCHES = _mdc.util.getMatchesProperty(HTMLElement.prototype);

              return {
                browserSupportsCssVars: function browserSupportsCssVars() {
                  return _mdc.util.supportsCssVariables(window);
                },
                isUnbounded: function isUnbounded() {
                  return _this.props.unbounded;
                },
                isSurfaceActive: function isSurfaceActive() {
                  return activator ? activator[MATCHES](':active') : surface[MATCHES](':active');
                },
                isSurfaceDisabled: function isSurfaceDisabled() {
                  return _this.props.disabled;
                },
                addClass: function addClass(className) {
                  if (!_this.isMounted_) {
                    return;
                  }

                  _this.setState({
                    classList: _this.state.classList.add(className)
                  });
                },
                removeClass: function removeClass(className) {
                  if (!_this.isMounted_) {
                    return;
                  }

                  var classList = _this.state.classList;
                  classList.delete(className);

                  _this.setState({
                    classList: classList
                  });
                },
                registerDocumentInteractionHandler: function registerDocumentInteractionHandler(evtType, handler) {
                  return document.documentElement.addEventListener(evtType, handler, _mdc.util.applyPassive());
                },
                deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(evtType, handler) {
                  return document.documentElement.removeEventListener(evtType, handler, _mdc.util.applyPassive());
                },
                registerResizeHandler: function registerResizeHandler(handler) {
                  return window.addEventListener('resize', handler);
                },
                deregisterResizeHandler: function deregisterResizeHandler(handler) {
                  return window.removeEventListener('resize', handler);
                },
                updateCssVariable: _this.updateCssVariable,
                computeBoundingRect: function computeBoundingRect() {
                  if (!_this.isMounted_) {
                    // need to return object since foundation expects it
                    return {};
                  }

                  if (_this.props.computeBoundingRect) {
                    return _this.props.computeBoundingRect(surface);
                  }

                  return surface.getBoundingClientRect();
                },
                getWindowPageOffset: function getWindowPageOffset() {
                  return {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                  };
                }
              };
            }, _this.handleFocus = function (e) {
              _this.props.onFocus(e);

              _this.foundation_.handleFocus();
            }, _this.handleBlur = function (e) {
              _this.props.onBlur(e);

              _this.foundation_.handleBlur();
            }, _this.handleMouseDown = function (e) {
              _this.props.onMouseDown(e);

              _this.activateRipple(e);
            }, _this.handleMouseUp = function (e) {
              _this.props.onMouseUp(e);

              _this.deactivateRipple(e);
            }, _this.handleTouchStart = function (e) {
              _this.props.onTouchStart(e);

              _this.activateRipple(e);
            }, _this.handleTouchEnd = function (e) {
              _this.props.onTouchEnd(e);

              _this.deactivateRipple(e);
            }, _this.handleKeyDown = function (e) {
              _this.props.onKeyDown(e);

              _this.activateRipple(e);
            }, _this.handleKeyUp = function (e) {
              _this.props.onKeyUp(e);

              _this.deactivateRipple(e);
            }, _this.activateRipple = function (e) {
              // https://reactjs.org/docs/events.html#event-pooling
              e.persist();
              requestAnimationFrame(function () {
                _this.foundation_.activate(e);
              });
            }, _this.deactivateRipple = function (e) {
              _this.foundation_.deactivate(e);
            }, _this.updateCssVariable = function (varName, value) {
              if (!_this.isMounted_) {
                return;
              }

              var updatedStyle = Object.assign({}, _this.state.style);
              updatedStyle[varName] = value;

              _this.setState({
                style: updatedStyle
              });
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(RippledComponent, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              if (!this.foundation_) {
                throw new Error('You must call initRipple from the element\'s ' + 'ref prop to initialize the adapter for withRipple');
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (this.foundation_) {
                this.isMounted_ = false;
                this.foundation_.destroy();
              }
            } // surface: This element receives the visual treatment (classes and style) of the ripple.
            // activator: This element is used to detect whether to activate the ripple. If this is not
            // provided, the ripple surface will be used to detect activation.

          }, {
            key: 'render',
            value: function render() {
              var _props = this.props,
                  unbounded = _props.unbounded,
                  style = _props.style,
                  className = _props.className,
                  onMouseDown = _props.onMouseDown,
                  onMouseUp = _props.onMouseUp,
                  onTouchStart = _props.onTouchStart,
                  onTouchEnd = _props.onTouchEnd,
                  onKeyDown = _props.onKeyDown,
                  onKeyUp = _props.onKeyUp,
                  onFocus = _props.onFocus,
                  onBlur = _props.onBlur,
                  otherProps = _objectWithoutProperties(_props, ['unbounded', 'style', 'className', 'onMouseDown', 'onMouseUp', 'onTouchStart', 'onTouchEnd', 'onKeyDown', 'onKeyUp', 'onFocus', 'onBlur']);

              var updatedProps = Object.assign(otherProps, {
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp,
                onTouchStart: this.handleTouchStart,
                onTouchEnd: this.handleTouchEnd,
                onKeyDown: this.handleKeyDown,
                onKeyUp: this.handleKeyUp,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                // call initRipple on ref on root element that needs ripple
                initRipple: this.initializeFoundation_,
                className: this.classes,
                style: this.style
              });
              return _react2.default.createElement(WrappedComponent, updatedProps);
            }
          }, {
            key: 'classes',
            get: function get() {
              var wrappedComponentClasses = this.props.className;
              var classList = this.state.classList;
              return (0, _classnames2.default)(Array.from(classList), wrappedComponentClasses);
            }
          }, {
            key: 'style',
            get: function get() {
              var wrappedStyle = this.props.style;
              var style = this.state.style;
              return Object.assign({}, style, wrappedStyle);
            }
          }]);

          return RippledComponent;
        }(_react.Component);

        WrappedComponent.propTypes = Object.assign({
          unbounded: _propTypes2.default.bool,
          disabled: _propTypes2.default.bool,
          style: _propTypes2.default.object,
          className: _propTypes2.default.string,
          onMouseDown: _propTypes2.default.func,
          onMouseUp: _propTypes2.default.func,
          onTouchStart: _propTypes2.default.func,
          onTouchEnd: _propTypes2.default.func,
          onKeyDown: _propTypes2.default.func,
          onKeyUp: _propTypes2.default.func,
          onFocus: _propTypes2.default.func,
          onBlur: _propTypes2.default.func
        }, WrappedComponent.propTypes);
        WrappedComponent.defaultProps = Object.assign({
          unbounded: false,
          disabled: false,
          style: {},
          className: '',
          onMouseDown: function onMouseDown() {},
          onMouseUp: function onMouseUp() {},
          onTouchStart: function onTouchStart() {},
          onTouchEnd: function onTouchEnd() {},
          onKeyDown: function onKeyDown() {},
          onKeyUp: function onKeyUp() {},
          onFocus: function onFocus() {},
          onBlur: function onBlur() {}
        }, WrappedComponent.defaultProps);
        RippledComponent.propTypes = WrappedComponent.propTypes;
        RippledComponent.defaultProps = WrappedComponent.defaultProps;
        RippledComponent.displayName = 'WithRipple(' + getDisplayName(WrappedComponent) + ')';
        return RippledComponent;
      };

      function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
      }

      exports.default = withRipple;
      /***/
    },
    /* 5 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
      /***/
    }])
  );
});